<template>
  <div class="article-container content">
    <div class="ui-crumbs">
      当前位置：
      <router-link to="/">首页</router-link>>
      <router-link to="/News">新闻动态</router-link>>
      <span>正文</span>
    </div>
    <div class="article-header">
      <h1>{{detail.news_title}}</h1>
      <span>作者：{{detail.operation}} 时间：{{detail.add_time}}</span>
    </div>
    <div class="article-content">
      <p v-html="$options.filters.unescape(detail.news_content)"></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      newsId: this.$route.query.newsId,
      detail: ""
    };
  },
  filters: {
    unescape: function(html) {
      if (html) {
        return html
          .replace(html ? /&(?!#?\w+;)/g : /&/g, "&amp;")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&quot;/g, '"');
      }
    }
  },
  mounted: function() {
    this.axios
      .get("/niuniu_api.php?action=get_news", {
        params: {
          id: this.newsId
        }
      })
      .then(response => {
        let res = response.data;
        if (res.errcode == 0) {
          this.detail = res.data;
        } else {
          console.log(res.errmsg);
        }
      });
  }
};
</script>

                        
<style scoped>
.ui-crumbs {
  height: 60px;
  line-height: 60px;
  /* border-bottom: 1px solid #ddd; */
  font-size: 14px;
}
.ui-crumbs a:hover {
  color: #e23251;
}
.article-header {
  border-bottom: 1px solid #ddd;
}
.article-header h1 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
}
.article-header {
  padding: 40px 0 10px;
}

.article-header span {
  display: block;
  padding-right: 100px;
  text-align: right;
  color: #7f7f7f;
  font-size: 12px;
}

.article-content {
  padding: 40px 0 90px;
}
.article-content p {
  font-size: 14px;
  color: #000;
  text-indent: 2em;
  line-height: 26px;
  word-break: break-all;
}

.article-container img {
  max-width: 100%;
  margin: 10px 0;
}
@media (max-width: 767px) {
  .content {
    width: auto;
  }
  .article-container {
    padding: 0 10px;
  }
  .article-header span {
    padding-right: 0;
  }
}
</style>